import React, { useState } from 'react';
import { Input, Button } from 'antd';
import { useAuth } from '../../contexts/auth';
import './style.css';

import logo from '../../assets/logo.png';

function Login() {
  const context = useAuth();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(false);
  async function handleLogin() {
    if(username.length < 3 || password.length < 6) {
      return setError('Preencha todos os campos para efetuar o login.');
    }
    const signin = await context.signin({ username, password });
    if(signin?.error) {
      return setError('Usuário e/ou senha inválidos.');
    }
  }
  return (
    <div id="login-body">
      <div id="login-card">
        <img alt="Logo" className="logo" src={logo} height="100px" width="100px"
          style={{ marginBottom: '30px' }}
        />
        <Input
          className="login-input"
          placeholder="Usuário"
          size="large"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
        />
        <Input.Password
          className="login-input"
          placeholder="Senha"
          size="large"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        {context.sessionExpired && (
          <p style={{ marginTop: '10px', fontSize: '10px', fontWeight: 'bold', color: '#e74c3c' }}>
            Sua sessão expirou, efetue o login novamente.
          </p>
        )}
        {!!error && (
          <p style={{ marginTop: '10px', fontSize: '10px', fontWeight: 'bold', color: '#e74c3c' }}>
            {error}
          </p>
        )}
        <Button className="login-button" type="primary" size="large" onClick={handleLogin}>
          Login
        </Button>
      </div>
    </div>
  );
}

export default Login;